$(document).ready(function(){
  var mySwiper = new Swiper ('.rotatetext_slider', {
    autoplay: {
      delay: 3,
      disableOnInteraction: false
    },
    slidesPerView: 5,
    speed: 50000,
    spaceBetween: 30,
    loop: true,
  });
});

$(function() {
    $(".badge h1").lettering();
  });